import React from 'react';
import { Classes } from '@blueprintjs/core';
import MultiSelectContacts from '../../contact/multi-select';
import { IContact } from '../../../../libs/contact';
import Dialog from '../index';

interface SelectContactsProps {
  isDialogOpen: boolean;
  toggleDialog: () => void;
  selected: IContact[];
  updateSelected: any;
}

const SelectContactsDialog: React.FC<SelectContactsProps> = ({
  isDialogOpen,
  toggleDialog,
  selected,
  updateSelected: _updateSelected
}) => {
  const updateSelected = (contacts: IContact[]) => {
    const ids = contacts.map((contact) => contact.id);
    _updateSelected('filters.contactIds', ids);
  };

  return (
    <Dialog
      title="Select Contacts Filter"
      isOpen={isDialogOpen}
      onClose={toggleDialog}
      forceScrollY
    >
      <div className={Classes.DIALOG_BODY}>
        <p>If you do not want to filter against contacts, do not select any.</p>
        <MultiSelectContacts
          selected={selected}
          updateSelected={updateSelected}
        />
      </div>
    </Dialog>
  );
};

export default SelectContactsDialog;
